<template>
  <div>
    <click-to-edit
      v-model="scope.row.scale.expectation_above"
      :disabled="!isFieldAvailableForEdit(scope.row, 'scale.expectation_above')"
      placeholder=""
      type="textarea"
      style="width: 100%"
      @input="saveElementPropChange(scope.row, 'scale', {expectation_above:$event})"
    ></click-to-edit>
  </div>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import {variables} from "@/componentsCompany/smz/variables";
export default {
  name: 'element-expectation-above-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {
      scaleTypesEnum: variables.scaleTypesEnum,
    }
  },
  computed: {},
  methods: {

  }
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

</style>
